module.exports = __webpack_public_path__ + "img/03_no.c522d5dc.svg";